import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";
import { Login } from './pages/Login';
import { ErrorBoundary } from './components/ErrorBoundary';
// Contest page disabled until the contest runs (accounts it created used a shared
// hardcoded password — re-design its auth before re-enabling):
// import { TdContest } from './pages/TdContest';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <div>
      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <ErrorBoundary>
        <Router>
          <Routes>
            {/* <Route path="/about" element={<div style={{color: 'white'}}>Hello</div>} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/signin" element={<div style={{color: 'white'}}>Hello</div>} />
            {/* <Route path="/tdcontest" element={<TdContest/>} /> */}
            <Route path="/" element={<App />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  </React.StrictMode>
);
